import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmProvider";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Orders from "@/pages/Orders";
import OrderCreate from "@/pages/OrderCreate";
import OrderDetail from "@/pages/OrderDetail";
import Receipt from "@/pages/Receipt";
import PublicReceipt from "@/pages/PublicReceipt";
import PublicLoyaltyCard from "@/pages/PublicLoyaltyCard";
import Services from "@/pages/Services";
import PaymentMethods from "@/pages/PaymentMethods";
import Agents from "@/pages/Agents";
import Loyalty from "@/pages/Loyalty";
import Promotions from "@/pages/Promotions";
import Reports from "@/pages/Reports";
import CashClosing from "@/pages/CashClosing";
import SettingsPage from "@/pages/Settings";
import ProClients from "@/pages/ProClients";
import ProClientDetail from "@/pages/ProClientDetail";
import ProInvoice from "@/pages/ProInvoice";
import ProStatement from "@/pages/ProStatement";
import Accounting from "@/pages/Accounting";

function Protected({ children, admin = false }) {
  const { authed, isAdmin } = useAuth();
  if (authed === undefined) return <div className="min-h-screen grid place-items-center text-slate-400">Chargement...</div>;
  if (!authed) return <Navigate to="/login" replace />;
  if (admin && !isAdmin) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/r/:id" element={<PublicReceipt />} />
      <Route path="/carte/:id" element={<PublicLoyaltyCard />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/customers" element={<Protected><Customers /></Protected>} />
      <Route path="/customers/:id" element={<Protected><CustomerDetail /></Protected>} />
      <Route path="/orders" element={<Protected><Orders /></Protected>} />
      <Route path="/orders/new" element={<Protected><OrderCreate /></Protected>} />
      <Route path="/orders/:id/edit" element={<Protected><OrderCreate /></Protected>} />
      <Route path="/orders/:id" element={<Protected><OrderDetail /></Protected>} />
      <Route path="/orders/:id/receipt" element={<Protected><Receipt /></Protected>} />
      <Route path="/cash" element={<Protected><CashClosing /></Protected>} />
      <Route path="/pro" element={<Protected><ProClients /></Protected>} />
      <Route path="/pro/clients/:id" element={<Protected><ProClientDetail /></Protected>} />
      <Route path="/pro/clients/:id/statement" element={<Protected><ProStatement /></Protected>} />
      <Route path="/pro/invoices/:id" element={<Protected><ProInvoice /></Protected>} />
      <Route path="/comptabilite" element={<Protected admin><Accounting /></Protected>} />
      <Route path="/reports" element={<Protected admin><Reports /></Protected>} />
      <Route path="/services" element={<Protected admin><Services /></Protected>} />
      <Route path="/payment-methods" element={<Protected admin><PaymentMethods /></Protected>} />
      <Route path="/agents" element={<Protected admin><Agents /></Protected>} />
      <Route path="/loyalty" element={<Protected admin><Loyalty /></Protected>} />
      <Route path="/promotions" element={<Protected admin><Promotions /></Protected>} />
      <Route path="/settings" element={<Protected admin><SettingsPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-right" />
      <BrowserRouter>
        <AuthProvider>
          <ConfirmProvider>
            <AppRoutes />
          </ConfirmProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
